import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as portalContactActions from '../../actions/portal-contact/portalContactActions';
import * as departmentsActions from '../../actions/portal-contact/departmentsActions'
import ContactPerson from './ContactPerson';
import _ from 'lodash';

class ContactPersons extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.actions.loadDepartments(1, { orderBy: 'sorter' });
        if(this.props.user.company) {
            this.props.actions.loadCompanyPortalContacts(this.props.user.company.id)
        }
    }

    renderList() {
        return this.props.list.map((departmentListItem) => {
            return (
                <div className="card-block" key={departmentListItem.id}>
                    <h4 className="m-t-20 m-b-20">
                        {departmentListItem.name}
                    </h4>
                    <div className="row" key={departmentListItem.id}>
                        {
                            departmentListItem.contacts.map(contact => {
                                return (
                                    <ContactPerson
                                        key={contact.id}
                                        name={contact.name}
                                        phone={contact.phone}
                                        email={contact.email}
                                        image={contact.photo[0] !== undefined ? contact.photo[0].path : ''}
                                        classes={this.props.itemClasses}
                                    />
                                );
                            })
                        }
                    </div>
                </div>
            )
        });
    }

    render() {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="card m-b-20">
                        {!this.props.hideTitle && <h3 className="card-header m-0 bg-gray">Jeres kontaktpersoner</h3>}
                        {this.renderList()}
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        user: state.user,
        list: portalContactsSelector(state.departments.data, state.companyPortalContacts, ownProps.departmentFilter)
    };
}

//@TODO Move [formatOne], [formatList], [filterContacts] members to selectors directory
function formatDepartment(department, portalContacts) {
    return {
        name: department.name,
        id: department.id,
        contacts: filterContacts(portalContacts, department.id)
    }
}

function portalContactsSelector(departments, portalContacts, departmentFilter) {
    if (departments && departments.length > 0 && portalContacts.length > 0) {
        if (departmentFilter) {
            departments = departments.filter(department => departmentFilter(department, portalContacts));
        }

        return departments
            .map(departments => formatDepartment(departments, portalContacts))
            .filter(item => !!item.contacts.length); // display department only with portal contacts
    }

    return [];
}

function filterContacts(contacts, id) {
    return contacts.filter(contact => {
        if (contact.department.isDefault === false && contact.department.id === id) {
            return contact;
        }
    });
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                portalContactActions,
                departmentsActions
            ), dispatch
        )
    }

}


export default connect(mapStateToProps, mapDispatchToProps)(ContactPersons);


// WEBPACK FOOTER //
// ./web/src/components/dashboard/ContactPersons.jsx